import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { distributorConfig } from './distributorConfig';
import { createDistributorValidationSchema } from './distributorValidation';

/**
 * Initialize the Distributor module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  distributorConfig,
  createDistributorValidationSchema
);

/**
 * Create the DistributorPage using the generic module page factory
 */
const DistributorPage = createModulePage(
  initializedConfig,
  {
    displayName: 'DistributorPage',
    description: 'Distributor Management System - Distributor information and contact management'
  }
);

export default DistributorPage;

